<template>
  <aside class="iv2-extra-nav text-center d-md-block">
    <nav class="iv2-extra-nav__sub-menu">
      <ul class="iv2-extra-nav__sub-list list-unstyled">
        <li
          v-for="nav in extra"
          :key="nav.id"
          class="iv2-extra-nav__sub-item theme__extra-bg"
        >
          <router-link
            v-if="nav.link_type == 'internal'"
            :to="nav.link_href + lang + query"
            :target="nav.target_type"
            class="iv2-extra-nav__sub-link theme__extra-link"
            @click.native="toPageTop()"
          >
            <i
              class="iv2-extra-nav__sub-item-icon d-block"
              :class="nav.item_icon"
            ></i>
            <span class="iv2-extra-nav__sub-item-text d-block">{{
              nav.item_name
            }}</span>
          </router-link>
          <a
            v-else-if="nav.link_type == 'external'"
            :href="nav.link_href"
            :target="nav.target_type"
            @click="closeMenu"
            rel="noopener"
            class="iv2-extra-nav__sub-link theme__extra-link"
          >
            <i
              class="iv2-extra-nav__sub-item-icon d-block"
              :class="nav.item_icon"
            ></i>
            <span class="iv2-extra-nav__sub-item-text d-block">{{
              nav.item_name
            }}</span>
          </a>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
export default {
  props: {
    extra: Array,
  },

  data() {
    return {
      query: "",
      lang: "",
    };
  },

  mounted() {
    if (this.$route.query.mode == "preview") {
      this.query = "?mode=preview";
    }
    if (this.$route.query.hl) {
      this.lang = "?hl=" + this.$route.query.hl;
    }
  },

  methods: {
    closeMenu() {
      var nav = document.getElementsByClassName("iv2-nav");
      var body = document.body;
      nav[0].classList.remove("active");
      body.classList.remove("noscroll");
    },

    toPageTop() {
      let currentPageIsTop = this.$route.path === "/";

      if (currentPageIsTop) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.iv2-extra-nav {
  right: 0;

  .iv2-extra-nav__sub-menu {
    height: 70px;

    .iv2-extra-nav__sub-list {
      display: flex;
      margin: 0;
      height: 100%;

      .iv2-extra-nav__sub-item {
        padding-top: 5px;
        border-left: 1px solid #eee;

        &:last-child {
          margin-bottom: 0;
        }

        .iv2-extra-nav__sub-link {
          -webkit-transition: 0.3s;
          transition: 0.3s;
          display: flex;
          margin: 20px;

          &:hover {
            text-decoration: none;
            opacity: 0.5;
          }
        }

        .iv2-extra-nav__sub-item-icon {
          font-size: 1.3rem;
          margin-right: 7px;
        }

        .iv2-extra-nav__sub-item-text {
          font-size: 13px;
          line-height: 1.3;
          padding-top: 2px;
        }
      }
    }
  }
}
</style>
